import React, { useEffect, useRef, useState, Suspense } from 'react';
import { Canvas, useFrame } from '@react-three/fiber';
import {Center, Html, OrbitControls, useGLTF} from '@react-three/drei';
import * as THREE from 'three';
import { isMobile } from 'react-device-detect';
import useInViewport from "../../hook/useInViewPort";

interface ModelProps {
    scrollY: number;
    scrollX: number;
    scrollZ: number;
    isVisible: boolean;
}

const Model: React.FC<ModelProps> = ({ scrollX, scrollZ, scrollY, isVisible }) => {
    const groupRef = useRef<THREE.Group>(null);
    const modelUrl = '/assets/3dModels/ship_in_clouds/ship_in_clouds_4k.glb';
    const gltf = useGLTF(modelUrl);

    useEffect(() => {
        if (groupRef.current) {
            const box = new THREE.Box3().setFromObject(groupRef.current);
            const center = new THREE.Vector3();
            box.getCenter(center);
            groupRef.current.position.sub(center);
            groupRef.current.scale.set(0.1, 0.1, 0.1);
        }
    }, []);

    useFrame(() => {
        if (groupRef.current && isVisible) {
            //groupRef.current.position.z = scrollZ * 0.0001;
            //groupRef.current.rotation.z = scrollY * -0.01;
            groupRef.current.rotation.y = scrollY * 0.00194;
        }
    });

    return (
        <group ref={groupRef}>
            <Center>
            <primitive object={gltf.scene} />
            </Center>
        </group>
    );
};

const ScrollableModel: React.FC = () => {
    const [scrollY, setScrollY] = useState(0);
    const [scrollX, setScrollX] = useState(0);
    const [scrollZ, setScrollZ] = useState(0.21);
    const { ref, isVisible } = useInViewport(0.1);

    useEffect(() => {
        const handleScroll = () => {
            setScrollY(window.scrollY);
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    return (
        <div style={{ height: '400vh', background: '#111' }} ref={ref}>
            <Canvas
                style={{ height: '100vh', width: '100%', backgroundImage: 'url(/assets/fallBackCloudy.png)', backgroundSize: 'cover' }}
                camera={{ position: [0, 0, 0.21], fov: 40 }}
            >
                <Suspense fallback={<Html><img alt="Fallback" src='/assets/fallBackCloudy.png' /></Html>}>
                    <Model isVisible={isVisible} scrollX={scrollX} scrollY={scrollY} scrollZ={scrollZ} />
                </Suspense>
                <OrbitControls enableZoom={false} enableRotate={!isMobile} enablePan={!isMobile} />
            </Canvas>
        </div>
    );
};

export default ScrollableModel;
